module.exports = __webpack_public_path__ + "img/ldx_lct@2x.8e3e862e.png";